<div class="sf-dialog-header">
	<h4 class="sf">{{ dialogTitle | translate }}</h4>
	<mat-icon [mat-dialog-close]="false" class="close-icon">close</mat-icon>
</div>

<mat-dialog-content>
	<ng-container [ngSwitch]="view">
		<div *ngSwitchCase="'form'" [formGroup]="form" class="form-wrapper">
			<div *ngIf="farms.length > 1" class="field-wrapper">
				<span class="field-label">{{
					'sf.shared_component.my_account.devices_section.add_device_dialog.farm' | translate
				}}</span>
				<mat-form-field appearance="outline" color="accent">
					<mat-select formControlName="farmId" [disableOptionCentering]="true" panelClass="sf-select">
						<mat-option *ngFor="let farm of farms" [value]="farm.id">{{ farm.name }}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<sf-input
				formControlName="name"
				[type]="'text'"
				[label]="'sf.shared_component.my_account.devices_section.add_device_dialog.name' | translate"
				[placeholder]="'sf.shared_component.my_account.devices_section.add_device_dialog.name' | translate"
			></sf-input>
		</div>

		<div *ngSwitchCase="'loading'" class="loading-wrapper">
			<mat-spinner [diameter]="32" color="accent"></mat-spinner>
			<p>{{ 'sf.shared_component.my_account.devices_section.add_device_dialog.generating' | translate }}</p>
		</div>

		<div *ngSwitchCase="'result'" class="result-wrapper">
			<p class="sf-dialog-subtitle">
				{{
					(isPreview
						? 'sf.shared_component.my_account.devices_section.add_device_dialog.preview_warning'
						: 'sf.shared_component.my_account.devices_section.add_device_dialog.warning'
					) | translate
				}}
			</p>
			<div class="pairing-code">{{ pairingCode }}</div>
			<button
				mat-flat-button
				color="accent"
				[cdkCopyToClipboard]="pairingCode"
				(cdkCopyToClipboardCopied)="onCopyClick($event)"
			>
				{{ 'sf.shared_component.my_account.devices_section.add_device_dialog.copy' | translate }}
			</button>
		</div>
	</ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<ng-container *ngIf="view === 'form'">
		<button (click)="onSubmit()" mat-flat-button color="accent" [disabled]="form.invalid || submitting">
			<mat-spinner *ngIf="submitting; else submitLabel" [diameter]="20" color="accent"></mat-spinner>
			<ng-template #submitLabel>{{
				'sf.shared_component.my_account.devices_section.add_device_dialog.submit' | translate | uppercase
			}}</ng-template>
		</button>
		<button mat-flat-button color="primary" [mat-dialog-close]="false">
			{{ 'sf.common.cancel' | translate | uppercase }}
		</button>
	</ng-container>
	<button *ngIf="view === 'result'" mat-flat-button color="primary" [mat-dialog-close]="true">
		{{ 'sf.common.close' | translate | uppercase }}
	</button>
</mat-dialog-actions>
